export function serialisePaymentErrorData(action: {
    extra: {
        type: string;
        charge: string;
        code: string;
        decline_code: string;
        message: string;
    };
}) {
    return {
        type: action?.extra?.type,
        charge: action?.extra?.charge,
        code: action?.extra?.code,
        decline_code: action?.extra?.decline_code,
        message: action?.extra?.message
    };
}
